"use client";

import { InfoSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedInfoSection from "../Components/GeneratedInfoSection";

const Info: FC<InfoSectionProps> = (props) => {
  return <GeneratedInfoSection {...props} />;
};

export default Info;
